var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminProducersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true,
      forceTab: "".concat(_vm.isDistillery ? "distilleries" : "wineries")
    }
  }) : _vm._e(), _c("ProducerDetails", {
    attrs: {
      id: _vm.id,
      isWinery: _vm.isWinery,
      isDistillery: _vm.isDistillery,
      loggedUserData: _vm.loggedUserData,
      searchCriterias: _vm.searchCriterias,
      returnRoute: _vm.returnRoute
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };